<!-- 配货申请 -->
<template>
  <div class="backgroundGrey">
    <div v-if="applyList.length">
      <div class="applyItem" v-for="(item,index) in applyList" :key="index" @click="openDetail(item)">
        <div>
          <span>航班日期：</span>
          <span>{{ item.flightDate }}</span>
        </div>
        <div>
          <span>航线环：</span>
          <span>{{ item.flightNoRing }}</span>
        </div>
        <div>
          <span>航段环：</span>
          <span>{{ item.flightLineRing }}</span>
        </div>
      </div>
    </div>
    <EmptyTips :tipsList="['暂无可以申请','配货航班计划']" v-else />
  </div>
</template>

<script>
import EmptyTips from '@/components/common/EmptyTips'

export default {
  components: {
    EmptyTips,
  },
  data() {
    return {
      applyList: [],
    }
  },
  activated() {
    this.getFlights()
  },
  methods: {
    openDetail(item) {
      this.$utils.routerPush({
        name: 'FlightDetails',
        query: item,
      })
    },
    // 获取航班申请列表
    getFlights() {
      let url = `/api-sys/sell/staffFlightDutyRoster/getFlights?staffId=${this.$store.state.userInfo.userId}&companyId=${this.$store.state.userInfo.companyId}`
      this.$api.get(url).then((res) => {
        this.applyList = res.data
      })
    },
  },
}
</script>

<style lang="less" scoped>
</style>



// WEBPACK FOOTER //
// src/view/DistributionApplication/DistributionApplication.vue